
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'portals-platform-reference-fe',
  currentProjectVersion: 'static-1.1314',
  depVersions: {
  "portals-platform-reference-fe": "static-1.1314",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "foundations-assets": "static-1.5069",
  "foundations-theming": "static-1.4633",
  "foundations-theming-base": "static-1.3618",
  "foundations-theming-specialty": "static-1.2349",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8216",
  "hub-http-shared-msw-handlers": "static-1.10431",
  "hubspot-dlb": "static-2.1854",
  "react-dlb": "static-1.83",
  "data-fetching-client": "static-1.9852",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8298",
  "hub-http": "static-1.6412",
  "HubStyleTokens": "static-2.11669",
  "I18n": "static-7.1648",
  "js-cookie": "static-1.18",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1262",
  "quartz-config": "static-1.1065",
  "quartz-core": "static-1.6506",
  "quartz-routing": "static-1.717",
  "quick-fetch": "static-1.4052",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16898",
  "rpc-client-utils": "static-1.4852",
  "ui-addon-react-router-dom": "static-1.9728",
  "UIComponents": "static-3.8615",
  "usage-tracker": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-anonymous": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.5",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3534",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3564",
  "quartz-webpack": "static-1.3511",
  "bend-plugin-quartz-routing": "static-1.365",
  "webpack-env": "static-1.54",
  "bend-plugin-foundations-theming": "static-1.3116",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9620",
  "react-utils": "static-2.5475",
  "StyleGuideUI": "static-3.491",
  "stylex": "static-1.37",
  "HeadJS": "static-2.779",
  "quartz": "static-1.7287",
  "hs-test-utils-bend-plugin": "static-1.3327",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "ts-schema": "static-1.4214",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "bend-plugin-foundations-components": "static-1.4567",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.48",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2317",
  "ui-fonts": "static-1.931",
  "ui-images": "static-2.1209",
  "hs-locale-management": "static-1.215",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "ui-addon-i18n": "static-1.11341",
  "interframe": "static-3.4949",
  "usage-tracker-multi": "static-1-session-replay-endpoint-migration.5",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.856",
  "hubspotter-http": "static-1.4785",
  "icons": "static-2.667",
  "jasmine": "static-4.4517",
  "jasmine-runner": "static-1.6649",
  "mobile-manifest-mixins": "static-1.553",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.962",
  "quartz-head": "static-1.952",
  "quartz-i18n": "static-1.962",
  "quartz-test": "static-1.962",
  "quartz-tracking": "static-1.666",
  "trellis-components": "static-1.2336",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.5",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.262",
  "chirp-fetch": "static-1.2081",
  "cssUtils": "static-1.846",
  "HubStyle": "static-2.11976",
  "bender-build-tools": "static-1.3316",
  "usage-tracker-public": "static-1-session-replay-endpoint-migration.5",
  "react-input-autosize": "static-2.17",
  "foundations-components-test-utils": "static-1.5781",
  "SharedI18nStrings": "static-1.182",
  "sassPrefix": "static-1.160",
  "hubspotter-http-shared-msw-handlers": "static-1.10429",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.5",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1142",
  "tanstack-virtual": "static-1.33",
  "amplitude-session-replay-browser": "static-1.60",
  "foundations-components-legacy": "static-1.1323"
},
  depPathPrefixes: {
  "portals-platform-reference-fe": "/portals-platform-reference-fe/static-1.1314",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "foundations-assets": "/foundations-assets/static-1.5069",
  "foundations-theming": "/foundations-theming/static-1.4633",
  "foundations-theming-base": "/foundations-theming-base/static-1.3618",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2349",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8216",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10431",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "react-dlb": "/react-dlb/static-1.83",
  "data-fetching-client": "/data-fetching-client/static-1.9852",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8298",
  "hub-http": "/hub-http/static-1.6412",
  "HubStyleTokens": "/HubStyleTokens/static-2.11669",
  "I18n": "/I18n/static-7.1648",
  "js-cookie": "/js-cookie/static-1.18",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1262",
  "quartz-config": "/quartz-config/static-1.1065",
  "quartz-core": "/quartz-core/static-1.6506",
  "quartz-routing": "/quartz-routing/static-1.717",
  "quick-fetch": "/quick-fetch/static-1.4052",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16898",
  "rpc-client-utils": "/rpc-client-utils/static-1.4852",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9728",
  "UIComponents": "/UIComponents/static-3.8615",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.5",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3534",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3564",
  "quartz-webpack": "/quartz-webpack/static-1.3511",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.365",
  "webpack-env": "/webpack-env/static-1.54",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3116",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9620",
  "react-utils": "/react-utils/static-2.5475",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.779",
  "quartz": "/quartz/static-1.7287",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3327",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "ts-schema": "/ts-schema/static-1.4214",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4567",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.48",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2317",
  "ui-fonts": "/ui-fonts/static-1.931",
  "ui-images": "/ui-images/static-2.1209",
  "hs-locale-management": "/hs-locale-management/static-1.215",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11341",
  "interframe": "/interframe/static-3.4949",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-session-replay-endpoint-migration.5",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.856",
  "hubspotter-http": "/hubspotter-http/static-1.4785",
  "icons": "/icons/static-2.667",
  "jasmine": "/jasmine/static-4.4517",
  "jasmine-runner": "/jasmine-runner/static-1.6649",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.553",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.962",
  "quartz-head": "/quartz-head/static-1.952",
  "quartz-i18n": "/quartz-i18n/static-1.962",
  "quartz-test": "/quartz-test/static-1.962",
  "quartz-tracking": "/quartz-tracking/static-1.666",
  "trellis-components": "/trellis-components/static-1.2336",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.5",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.262",
  "chirp-fetch": "/chirp-fetch/static-1.2081",
  "cssUtils": "/cssUtils/static-1.846",
  "HubStyle": "/HubStyle/static-2.11976",
  "bender-build-tools": "/bender-build-tools/static-1.3316",
  "usage-tracker-public": "/usage-tracker-public/static-1-session-replay-endpoint-migration.5",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5781",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "sassPrefix": "/sassPrefix/static-1.160",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10429",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.5",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1142",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1323"
}
};
